//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FullWidthVideo from "~/components/video-elements/fullWidthVideo";
import ProductPresentationHead from "~/components/loading-placeholders/product-presentation-head-pl";
import reciepeModal from "~/components/modal/reciepeModal";
import VueMarkdown from "vue-markdown";

export default {
  name: "product-information.vue",
  data() {
    return {
      prodSliderOpt: {
        arrows: false,
        dots: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 2000,
      },
      // sliderOptions: {
      //   arrows: false,
      //   dots: true,
      //   slidesToShow: 1,
      //   infinite: true,
      //   slidesToScroll: 1,
      // },
      // sliderOptions2: {
      //   arrows: false,
      //   slidesToShow: 1,
      //   slidesToScroll: 1,
      //   fade: true,
      // },
      currentName: null,
    };
  },

  // async asyncData({ store }) {
  //   await store.dispatch("our-product/getProductDetailsName");
  //   const seo = store.state["our-product"].productDetailsName.seo;
  //   const recipesData = store.state["our-product"].productDetailsName;
  //   return { seo, recipesData };
  // },
  components: {
    FullWidthVideo,
    ProductPresentationHead,
    reciepeModal,
    VueMarkdown,
  },
  async asyncData({ store, route, redirect }) {
    const cname = route.params.name.split("-").join(" ");
    if (typeof cname != undefined) {
      await store.dispatch("our-product/getProductDetailsName", cname);
    } else {
      redirect("/");
    }
    const seo = store.state["our-product"].productDetailsName.seo[0];
    return {
      cname,
      seo,
    };
  },
  head() {
    return {
      title: this.seo.meta_title,
      meta: [
        {
          name: "description",
          hid: "description",
          content: this.seo.meta_description,
        },
        {
          name: "og:description",
          hid: "og:description",
          content: this.seo.meta_description,
        },
        {
          name: "keywords",
          hid: "keywords",
          content: this.seo.keywords,
        },
        {
          property: "og:url",
          content: `https://www.dilmahtea.com${this.$route.path}`,
        },

        {
          property: "og:image",
          hid: "og:image",
          content: this.seo.share_image_url,
        },
        {
          property: "og:title",
          hid: "og:title",
          content: this.seo.meta_title,
        },
        {
          property: "og:image:alt",
          hid: "og:image:alt",
          content: this.seo.share_image_alt,
        },

        {
          name: "shareImageAlt",
          hid: "shareImage",
          content: this.seo.share_image_alt,
        },
        {
          name: "shareImage",
          hid: "shareImage",
          content: this.seo.share_image_url,
        },
        {
          name: "preventindex",
          hid: "preventindex",
          content: this.seo.prevent_indexing,
        },
      ],
    };
  },
  mounted() {
    this.$store.commit("our-product/CLEAR_RECIPE_DETAILS");
    this.$store.commit("our-product/CLEAR_PRODUCT_DETAILS_BY_NAME");
    // this.$store.dispatch("our-product/getProductDetailsName");
    this.currentName = this.$route.params.name.replaceAll("-", " ");
    if (typeof this.currentName != undefined) {
      this.$store.dispatch(
        "our-product/getProductDetailsName",
        this.currentName
      );
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    onQuestionChange(e, slick, current) {
      // this.$refs.infoSlide.goTo(current);
    },
    setIcon(text) {
      let reText = text.replace(/[^a-zA-Z ]/g, "");
      let trimText = reText.trim();
      return `icon-${trimText.split(" ").join("-")}`;
    },
    recipeClick(id) {
      this.$store.commit("our-product/CLEAR_RECIPE_DETAILS");
      this.$store.dispatch("our-product/getRecipes", id);
    },
  },
  computed: {
    // seo() {
    //   if (this.$store.state["our-product"].productDetailsName != null) {
    //     return this.$store.state["our-product"].productDetailsName.seo[0];
    //   }
    // },
    productData() {
      if (this.$store.state["our-product"].productDetailsName != null) {
        return this.$store.state["our-product"].productDetailsName.data[0];
      }
    },

    recipes() {
      if (this.$store.state["our-product"].productDetailsName != null) {
        return this.$store.state["our-product"].productDetailsName.data[1]
          .recipes;
      }
    },
    selectedRecipe() {
      if (this.$store.state["our-product"].recipeDetails != null) {
        return this.$store.state["our-product"].recipeDetails.data[0];
      }
    },
    teaBags() {
      if (this.productData.number_of_tea_bags_available != null) {
        let newArr = [];
        this.productData.number_of_tea_bags_available.forEach((element) => {
          newArr.push(element + " tea bags");
        });
        return newArr;
      }
    },
    teaWeights() {
      if (this.productData.weight_available != null) {
        let newArr = [];
        this.productData.weight_available.forEach((element) => {
          newArr.push(element + " g");
        });
        return newArr;
      }
    },
  },
};
